module.exports = __webpack_public_path__ + "img/06-oval-not-convex-4-5-base.b8567f01.svg";